import React, {useCallback, useContext, useRef, useState} from "react"
import Menu, {MenuItem} from "@amzn/meridian/menu";
import Button from "@amzn/meridian/button"
import Icon from "@amzn/meridian/icon";
import menuTokens from "@amzn/meridian-tokens/base/icon/menu-meatball";
import {PickContext} from "./context/PickContext";
import {FormattedMessage} from "react-intl";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {AlertContext} from "../alert/context/AlertContext";
import {PickFilterContext} from "./context/PickFilterContext";
import {PICK_STATUS} from "../util/EntityStatusManager";

const PicklistContextMenu = (props) => {
    const {dispatch} = useContext(PickContext)
    const {configViewModel} = useContext(CapabilityContext)
    const {alertDispatch} = useContext(AlertContext)
    const {viewModelF, dispatchF} = useContext(PickFilterContext)

    const iconRef = useRef()
    const [open, setOpen] = useState(false)
    const onClickButton = useCallback(() => setOpen(true), [])
    const onClose = useCallback(() => setOpen(false), [])
    const unAssign = {title: "contextMenu.unAssign", message: "UnAssign"};

    const getMenuItem = () => {
        const menuItem = [];
        if (props.picklist.status === PICK_STATUS.IN_PROGRESS) {
            menuItem.push(unAssign)
        }
        return menuItem;
    }

    const executeAction = (menu) => {
        switch (menu) {
            case "UnAssign":
                dispatch({
                    type: 'UNASSIGN_ASSOCIATE', data: {
                        dispatcher: dispatch,
                        picklistId: props.picklist.picklistId,
                        associateId: props.picklist.pickerAlias,
                        stationCode: props.picklist.stationCode,
                        baseUrl: configViewModel.baseUrl,
                        alertDispatch: alertDispatch,
                        filterDispatcher: dispatchF,
                        xptNodes: viewModelF.xptNodes,
                        capability: configViewModel.capability,
                        stationConfig: configViewModel.stationConfig
                    }
                });
                return;
            default:
                return;
        }
    }

    return (
        <React.Fragment>
            <Button type="icon" ref={iconRef} onClick={onClickButton} size="small">
                <Icon tokens={menuTokens}>Settings</Icon>
            </Button>
            <Menu anchorNode={iconRef.current}
                  open={open}
                  position="right"
                  onClose={onClose}>
                {getMenuItem().map((menu, key) => (
                    <MenuItem key={key} onClick={() => executeAction(menu.message)}>
                        <FormattedMessage id={menu.title} defaultMessage={menu.message}/>
                    </MenuItem>
                ))}
            </Menu>
        </React.Fragment>
    );
}

export default PicklistContextMenu


// WEBPACK FOOTER //
// ./src/components/pickStatus/PicklistContextMenu.js